// angular
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from '../../../app.service';
import { MePaymentService } from '../me-payment.service';

@Component({
    selector: 'me-payment-verify',
    templateUrl: './payment-verify.component.html',
    styleUrls: ['./payment-verify.component.scss'],
    providers: [MePaymentService]
})

export class MePaymentVerifyComponent implements OnInit {
    showLoadingPage = true;
    showSuccessPage = false;
    showErrorPage = false;
    showDocument = false;

    constructor(
        public appService: AppService,
        public translate: TranslateService,
        public route: ActivatedRoute,
        public mePaymentService: MePaymentService
    ) {

    }

    ngOnInit() {
        this.appService.isLoading = false;
        this.route.params.subscribe(params => {
            let token = params['token'];
            this.mePaymentService.checkPayment(token).subscribe(res => {
                if (res['success']) {
                    this.showLoadingPage = false;
                    this.showSuccessPage = true;

                    if (res['type'] === 'Map') {
                        this.showDocument = true;
                    }
                } else {
                    this.showLoadingPage = false;
                    this.showErrorPage = true;
                }
            });
        });
    }
}
